import { Action } from 'redux';

export enum ActionType {
  SET_PENDING_STATUS = 'AUTOSAVE/SET_PENDING_STATUS',
  SET_SAVING_STATUS = 'AUTOSAVE/SET_SAVING_STATUS',
  SET_SUCCESSFULL_STATUS = 'AUTOSAVE/SET_SUCCESFULL_STATUS',
  SET_FAILED_STATUS = 'AUTOSAVE/SET_FAILED_STATUS',
}

export interface SetPendingStatus extends Action {
  type: ActionType.SET_PENDING_STATUS;
  timeout: NodeJS.Timeout | null;
  fieldName: string;
  fieldValue: string;
}

export const autosavePending = (
  fieldName: string,
  fieldValue: string,
  timeout: NodeJS.Timeout
): SetPendingStatus => ({
  type: ActionType.SET_PENDING_STATUS,
  timeout,
  fieldName,
  fieldValue,
});

export interface SetSavingStatus extends Action {
  type: ActionType.SET_SAVING_STATUS;
}

export const autosaveSaving = (): SetSavingStatus => ({
  type: ActionType.SET_SAVING_STATUS,
});

export interface SetSuccessfullStatus extends Action {
  type: ActionType.SET_SUCCESSFULL_STATUS;
}

export const autosaveSuccesfull = (): SetSuccessfullStatus => ({
  type: ActionType.SET_SUCCESSFULL_STATUS,
});

export interface SetFailedStatus extends Action {
  type: ActionType.SET_FAILED_STATUS;
}

export const autosaveFailed = (): SetFailedStatus => ({
  type: ActionType.SET_FAILED_STATUS,
});
